/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_No_WeightInputs */

const en_us2_coaching_no_weight = /** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No weight entries.`)
};

const pt_br2_coaching_no_weight = /** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem registros de peso.`)
};

const pt_pt2_coaching_no_weight = /** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem registros de peso.`)
};

/** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */
const es_419_coaching_no_weight = en_us2_coaching_no_weight;

/** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */
const fr_fr2_coaching_no_weight = en_us2_coaching_no_weight;

/** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */
const de_de2_coaching_no_weight = en_us2_coaching_no_weight;

/** @type {(inputs: Coaching_No_WeightInputs) => LocalizedString} */
const it_it2_coaching_no_weight = en_us2_coaching_no_weight;

/**
* | output |
* | --- |
* | "No weight entries." |
*
* @param {Coaching_No_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_no_weight = /** @type {((inputs?: Coaching_No_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_No_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_no_weight(inputs)
	if (locale === "es-419") return es_419_coaching_no_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_no_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_no_weight(inputs)
	if (locale === "de-DE") return de_de2_coaching_no_weight(inputs)
	if (locale === "it-IT") return it_it2_coaching_no_weight(inputs)
	return en_us2_coaching_no_weight(inputs)
});
export { coaching_no_weight as "coaching.no_weight" }